export enum EApi {
  
}
export const DEFAULT_SPLASH_VIDEO_DETAILS = {
  backgroundColor: "#101A26",
};
export const EXPONENTIAL_BACKOFF = [1, 2, 5];
export const API_REQUEST_TIME_OUT = 15000;
export const NETWORK_ERROR = 'Network Error';
export const TIME_OUT_EXCEED = 'timeout';
export const USER_TOKEN = 'USER_TOKEN';
export const USER_PRESIGNUP = "USER_PRESIGNUP"
export const RETRY_COUNT = 3;
export const DEFAULT_NUMBER_VALIDATION = '^\\+91[6789]\\d{9}$';
export const LOGIN_INPUT_REGEX = /^(\+91\s?)|[^0-9]/g;
export const SIGN_UP_ACTION = 'SignUp';
export const MAIN_CLIENT = 'MAIN_CLIENT';
export const SIGN_IN_ACTION = 'SignIn';
export const RESENT_OTP_TIME = 30;
export const SKELETON_TIMEOUT = 1500;
export const TIMEOUT_FOR_ONE_SEC = 1000;
export const RUPEE_ICON = '₹';
export const RESEND_OTP_DEBOUNCE_DELAY = 0;
export const PARTNER_ID_KEY = 'PARTNER_ID';
export const GOOGLE_LOGIN_KEY = 'GOOGLE_LOGIN_KEY';